import permissions from '../../data/permissions';

export default [
    {
        name: "GoodReceiptCreate",
        path: "receipt",
        component: () => import('./../../views/purchase/GoodReceiptCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.po_good_receipt.create }
    },
    {
        name: "GoodReceiptList",
        path: "receipts",
        component: () => import('./../../views/purchase/GoodReceiptListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.po_good_receipt.index }
    },
    {
        name: "GoodReceiptDisplay",
        path: "receipt/:id",
        component: () => import('./../../views/purchase/GoodReceiptDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.po_good_receipt.read }
    },
    {
        name: "GoodReceiptEdit",
        path: "receipt/:id/edit",
        component: () => import('./../../views/purchase/GoodReceiptEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.po_good_receipt.update }
    }
]